<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="modalNewCompetition"
       v-if="getPays && getNiveauxCompetitionPoomsae">
    <div class="modal-dialog">
      <div class="modal-content" v-if="newCompetition">
        <div class="overlay ModalOverlay" v-if="loading">
          <i class="fa fa-refresh fa-spin"></i>
        </div>

        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
            aria-hidden="true">×</span></button>
          <h4 class="modal-title"> Ajouter une compétition Poomsae</h4>
        </div>

        <div class="modal-body">
          <div class="form-group"
               :class="{'has-error': errors.has('competition[competition]') }">
            <label for="competition">Nom de la compétition Poomsae</label>
            <input type="text" class="form-control" id="competition" name="competition[competition]"
                   v-validate="'max:200'"
                   placeholder="Nom de la competition" v-model="newCompetition.competition">
            <span v-show="errors.has('competition[competition]')" class="help-block">Le nom de la competition doit comporter moins de 200 caractères</span>
          </div>

          <div class="form-group"
               :class="{'has-error': errors.has('competition[adresse]') }">
            <label for="adresse">Adresse</label>
            <textarea type="text" class="form-control" id="adresse" name="competition[adresse]"
                      placeholder="Adresse"
                      v-model="newCompetition.adresse">{{newCompetition.adresse}}</textarea>
          </div>

          <div class="form-group">
            <label for="ville">Pays</label>
            <select class="form-control" name="competition[id_pays]" v-model="newCompetition.id_pays">
              <option value="ZZ">Pays indéterminé
              </option>
              <optgroup label="Habituels">
                <option
                  v-for="pays in getPays.habituels"
                  :value="pays.id"
                >{{ pays.name }}
                </option>

              </optgroup>
              <optgroup label="Autres">
                <option
                  v-for="pays in getPays.all"
                  :value="pays.id"
                > {{ pays.name }}
                </option>
              </optgroup>
            </select>
            <!--<span class="help-block">Help block with error</span>-->
          </div>

          <date-avant-date-apres
            :dateDebutPrefill="this.newCompetition.date_debut"
            :dateFinPrefill="this.newCompetition.date_fin"
            @onDateDebutChange="setDateDebut"
            @onDateFinChange="setDateFin"
          ></date-avant-date-apres>

          <div class="form-group"
               :class="{'has-error': errors.has('competition[comments]') }">
            <label for="adresse">Commentaires</label>
            <textarea type="text" class="form-control" id="comments" name="competition[comments]"
                      placeholder="Commentaires éventuels"
                      v-model="newCompetition.comments">{{newCompetition.comments}}</textarea>
          </div>

          <div class="form-group">
            <label for="statut">Niveau de la compétition Poomsae</label>
            <select id="statut" class="form-control" name="competition[id_niveau]" v-model="newCompetition.id_niveau">
              <option
                v-for="niveau in getNiveauxCompetitionPoomsae"
                :value="niveau.id"
              >{{ niveau.niveau }}
              </option>
            </select>
          </div>

          <!-- <div class="checkbox">
            <label for="labelise">
              <input id="labelise" name="competition[labelise]" type="checkbox"
                     v-model="newCompetition.labelise">
              Labelisé ABFT – Poomsae
            </label>

          </div>

          <div class="checkbox">
            <label for="jo">
              <input id="jo" name="competition[jo]" type="checkbox"
                     v-model="newCompetition.jo">
              Jeux Olympiques (catégorie Poomsae)
            </label>
          </div>

          <div class="checkbox">
            <label for="new_categ">
              <input id="new_categ" name="competition[new_categ]" type="checkbox"
                     v-model="newCompetition.new_categ">
              Catégories de poids WTF/ABFT
            </label>
          </div>

          <div class="checkbox">
            <label for="olympique">
              <input id="olympique" name="competition[olympique]" type="checkbox" disabled
                     v-model="newCompetition.olympique">
              Catégorie de poids olympique
            </label>
          </div>

          <div class="checkbox">
            <label for="ab_dissociated">
              <input id="ab_dissociated" name="competition[ab_dissociated]" type="checkbox"
                     v-model="newCompetition.ab_dissociated">
              Catégories de poids A et B séparées (ex.: Indoor Brussels)
            </label>
          </div>-->
        </div> 

        <div class="modal-footer">
          <button type="button"
                  class="btn btn-default pull-left" data-dismiss="modal">
            Fermer
          </button>
          <button type="button"
                  class="btn btn-primary"
                  :disabled="errors.count()!=0 || this.disabledBtn || this.loadingInputs.length>0"
                  @click="addCompetition()"
          >
            Ajouter une compétition Poomsae
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {ErrorBag} from 'vee-validate';
import DateAvantDateApres from '../../Communs/DateAvantDateApres'

var $ = require('jquery');
var _ = require('underscore')
var moment = require('moment')

export default {
  data() {
    return {
      loadingInputs: [],
      disabledBtn: false,
      newCompetition: null,
      loading: false,
    }
  },
  computed: {
    ...mapGetters({
      getRoute: 'getRoute',
      getPays: 'getPays',
      getListeCompetitionPoomsae: 'getListeCompetitionPoomsae',
      getNiveauxCompetitionPoomsae: 'getNiveauxCompetitionPoomsae',
    }),
  },
  mounted: function () {
    var these = this
    this.newCompetition = this.declareCompetition()
  },
  beforeRouteEnter(to, from, next) {
    // vm.newCompetition = vm.declareCompetition();
    next()
  },
  watch: {},
  components: {
    DateAvantDateApres,
  },
  methods: {
    ...mapActions({}),
    setDateDebut: function (value) {
      this.newCompetition.date_debut = value;
    },
    setDateFin: function (value) {
      this.newCompetition.date_fin = value;
    },
    addCompetition: function () {
      this.disabledBtn = true;
      let self = this;
      this.$http.post(this.getRoute('Secretariat.competitionPoomsae.store'), this.constructForm()).then(function (response) {
        self.$noty.success("La competition a bien été créée")
        self.disabledBtn = false
        self.newCompetition = self.declareCompetition()
        self.$router.push({name: 'CompetitionPoomsae', params: {competition_id: response.body.id}})
        $('#modalNewCompetition').modal('hide')
      }, (response) => {
        self.$noty.error("Erreur dans la création de la nouvelle competition")
        self.disabledBtn = false
        $('#modalNewCompetition').modal('hide')
      });
    },
    currentYear: function () {
      return moment().year();
    },
    console: function (event) {
      console.log(event);
    },
    declareCompetition: function () {
      return {
        competition: "",
        adresse: "",
        date_debut: moment().format('DD/MM/YYYY'),
        date_fin: moment().format('DD/MM/YYYY'),
        id_pays: 'BE',
        labelise: 0,
        id_niveau: 1,
        jo: 0,
        new_categ: 1,
        olympique: 0,
        ab_dissociated: 0,
        comments: "",
      }

    },
    constructForm: function () {
      return JSON.stringify({
        "competition": this.newCompetition.competition,
        "adresse": this.newCompetition.adresse,
        "date_debut": this.formatDate(this.newCompetition.date_debut, "DD/MM/YYYY", "YYYY-MM-DD"),
        "date_fin": this.formatDate(this.newCompetition.date_fin, "DD/MM/YYYY", "YYYY-MM-DD"),
        "id_pays": this.newCompetition.id_pays,
        // "labelise": this.newCompetition.labelise,
        "id_niveau": this.newCompetition.id_niveau,
        // "jo": this.newCompetition.jo,
        // "new_categ": this.newCompetition.new_categ,
        // "olympique": this.newCompetition.olympique,
        // "ab_dissociated": this.newCompetition.ab_dissociated,
        "comments": this.newCompetition.comments,
      })
    },
    formatDate: function (value, fmtIn = 'YYYY-MM-DD hh:mm:ss', fmtOut = 'DD/MM/YYYY HH:mm') {
      if (value == null) return ''
      return moment(value, fmtIn).format(fmtOut)
    },
    isInputLoading: function (input) {
      return _.indexOf(this.loadingInputs, input) >= 0 ? true : false
    },
    addToLoadingInputs: function (input) {
      this.loadingInputs.push(input)
    },
    removeFromLoadingInputs: function (input) {
      this.loadingInputs = _.without(this.loadingInputs, input)
    },
  },
  filters: {
    idFormat: function (value) {
      return new Intl.NumberFormat("de-DE").format(value)
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Secretariat/CompetitionPoomsae/ModalNewCompetitionPoomsae.vue